import * as React from 'react';

import { Box, IconSearch, Text, TextInput } from '@tocktix/pantry';

interface UserSearchProps {
  query: string;
  onQueryChanged: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const inputStyles: React.CSSProperties = {
  fontSize: '16px',
  letterSpacing: '-0.25px',
};

const isBareDigits = (value: string): boolean => /^\d+$/.test(value.trim());

const UserSearch: React.FunctionComponent<UserSearchProps> = ({ query, onQueryChanged }) => {
  return (
    <Box display="flex" flexDirection="column" gap={100}>
      <Box
        display="flex"
        alignItems="center"
        borderRadius="round"
        bgColor="surfaceDefault"
        border="borderDefault"
        style={{ height: '44px', overflow: 'hidden' }}
      >
        <TextInput
          id="query"
          name="query"
          data-testid="user-search-input"
          aria-labelledby="search-icon"
          placeholder="Search by name, email, Resy/Tock ID, or +phone (min 3 characters)"
          value={query}
          onChange={onQueryChanged}
          startElement={
            <IconSearch id="search-icon" aria-label="Search for user" size={200} color="fgSubtle" />
          }
          fullWidth
          style={inputStyles}
        />
      </Box>
      <Text variant="bodySm" color="fgSubtle" data-testid="user-search-help">
        Phone: include + and country code (e.g. +1 415 555 1234). Bare numbers search Resy/Tock ID.
      </Text>
      {isBareDigits(query) && (
        <Text variant="bodySm" color="fgSubtle" data-testid="user-search-digit-tip">
          Searching by Resy/Tock ID. For a phone number, add + and the country code.
        </Text>
      )}
    </Box>
  );
};

export default UserSearch;
